import { Col, Row, Typography } from "antd";
import { Fragment } from "react/jsx-runtime";
import { PRIVACY } from "../../../constants/AppConstants";

import "./Prospects.css";

const { Title, Paragraph } = Typography;

export default function Prospects() {
  return (
    <Row className="my-40">
      <Col xs={1} sm={1} md={2} lg={4}></Col>
      <Col xs={22} sm={22} md={20} lg={16}>
        <Title className="privacy-prospects-title" level={3}>
          {PRIVACY.PROPECTS.TITLE}
        </Title>
        {PRIVACY.PROPECTS.CONTENT.map((content, x) => (
          <Fragment key={x}>
            <Title level={4}>{content.SUBTITLE}</Title>
            {content.TEXT.map((textos, y) => (
              <Paragraph className="privacy-prospects-description" key={y}>
                {textos.split("\n").map((texto, z) => (
                  <Fragment key={z}>
                    {texto}
                    <br />
                  </Fragment>
                ))}
              </Paragraph>
            ))}
          </Fragment>
        ))}
      </Col>
      <Col xs={1} sm={1} md={2} lg={4}></Col>
    </Row>
  );
}
